// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthLayout_wrapper__K5LCC"};